exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n  overflow-x: hidden;\n  background-color: #f6f9fc;\n  font-family: Roboto, Open Sans, Segoe UI, sans-serif;\n  font-size: 15px;\n  font-weight: 500; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/evaleto/nodejs/evaletolab.ch/visashift-app/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/evaleto/nodejs/evaletolab.ch/visashift-app/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/home/evaleto/nodejs/evaletolab.ch/visashift-app/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/home/evaleto/nodejs/evaletolab.ch/visashift-app/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles